const initialState = {
    findLocation:{
        lat:29.618716,
        lng:52.487361,
    },
    loaderFindLocation:false,
};
const map = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_FIND_LOCATION':
            return {...state,findLocation:{lat: action.lat,lng:action.lng}};
        case "CHANGE_LOADER_FINAL_LOCATION_MAP":
            return {...state,loaderFindLocation: action.loaderFindLocation};
        default:
            return state;
    }
};

export default map;
